import { HomeManualFieldProjection } from "../definitions";

export function getSectionContent(section: HomeManualFieldProjection) {
  return section.value || section.defaultValue;
}
